import { StateScheme } from 'app/providers/StoreProvider/config/StateScheme'

export const getStatisticsLoading = (state: StateScheme) => {
    return state.statistics.statisticsLoading
}
